import { Component, OnInit, Input } from '@angular/core';
import { Course } from 'lms-api';
import { CourseBundle } from 'lms-api';
import { LMSDataService } from 'lms-api';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-related-bundle-list',
  templateUrl: './related-bundle-list.component.html',
  styleUrls: ['./related-bundle-list.component.scss']
})
export class RelatedBundleListComponent implements OnInit {
  @Input() course: Course;
  public bundlesWithCourse: CourseBundle[];

  constructor(private ucdService: UserCourseDataService) {
    this.bundlesWithCourse = [];
  }

  ngOnInit() {
    this.ucdService.Bundles$.subscribe(bundles => {
      this.bundlesWithCourse = [];
      bundles.forEach(bundle => {
        if (bundle.courseIds.includes(this.course.netforum_course_id)) {
          this.bundlesWithCourse.push(bundle);
        }
      })
    });
  }

}
